import { useMemo } from "react";
import { readEligibilityOptions } from "api/get-app-init-details";
import { useAppInitDetails } from "hooks/use-app-init-details/use-app-init-details.hook";

// Signals whether the authenticated member has more than one K-ID. Consumers
// (currently `PrivateRoutesContainer`) pair this with a per-mount visit ref
// on `/switch-account` to fire the login gate exactly once per authenticated
// session — parity with iOS `PostAuthenticationCoordinator` running
// `PolicySwitcherCoordinator` when `eligibilityOptions.count > 1`
// (EMBLEM-7088). No cross-session storage is used because Auth0's
// full-page redirect flow preserves `sessionStorage`, which caused stale
// flags to suppress the gate on subsequent logins.
export const usePlanSwitcherLoginGate = () => {
  const { data: appInit, isLoading } = useAppInitDetails();

  const hasMultiplePlans = useMemo(
    () => readEligibilityOptions(appInit).length > 1,
    [appInit]
  );

  return { hasMultiplePlans, isLoading };
};
